module.exports = __webpack_public_path__ + "img/yalda_yafa_no.4f716a18.png";